<template>
    <div>
        <treeselect
            :async="true"
            :load-options="loadOptions"
            :loading="looking"
            :multiple="multiple"
            openDirection="bottom"
            placeholder="Typ om te zoeken..."
            v-model="currentObject"
            ref="selector"
        />
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';

export default {
    name: 'async-selector',
    components: {Treeselect},
    props: {
        multiple: {
            type: Boolean,
            required: false,
            default: true,
        },
        selected: {
            type: Array,
            required: false,
            default: () => []
        },
        identifier: {
            type: String,
            default: 'id'
        },
        label: {
            type: String,
            default: 'name'
        },
        shop: {
            type: String
        },
        apiUrl: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            saved: false,
            sourceLoaded: false,
            currentObject: [],
            looking: false,
        }
    },
    methods: {
        save: function () {
            this.saved = true;
            return {
                [this.name]: this.value
            }
        },
        reset: function () {
            if (!this.saved) {
                this.value = this.$props.selected;
            }
        },
        loadOptions({searchQuery, callback}, init) {
            if (!this.looking) {
                this.looking = true;
                axios.post(`${this.apiUrl}?query=${searchQuery}`, {})
                    .then(response => {
                        return callback(null, response.data.data);
                    })
                    .finally(() => {
                        this.looking = false;
                    });
            }
        },
        initOptions() {
            axios.post(`${this.apiUrl}`, {
                "init": true,
                "values": this.currentObject,
            })
                .then(response => {
                    let data = response.data.data;
                    let nodeMap = this.$refs.selector.forest.nodeMap;
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (nodeMap[item.id] !== undefined) {
                            nodeMap[item.id].label = item.label;
                        }
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.looking = false;
                });
        },
        syncValues() {
            this.currentObject = this.selected.length ? this.selected : null;
        },
    },
    watch: {
        currentObject(newValue, oldValue) {
            this.$emit('updated', newValue);
        }
    },
    created() {
        this.syncValues();
    },
    mounted() {
        this.initOptions();
    }

}
</script>

<style>
.vue-treeselect__menu-container {
    z-index: 9999999;
}
</style>
